<div class="ob-flex">
	<h4>{{ "i18n.mmmi.verification.status.header" | translate }}</h4>
	<div>
		<button class="trash-button" mat-icon-button obButton="secondary" (click)="model.removeRows()">
			<mat-icon svgIcon="trash"></mat-icon>
		</button>
	</div>
</div>

<div class="table-responsive">
	<table mat-table [dataSource]="model.dataSource" ngClass="ob-table-sm">
		<ng-container *ngFor="let column of model.columns" [matColumnDef]="column.key">
			<th mat-header-cell *matHeaderCellDef>
				{{ "i18n.mmmi.verification.status.columns." + column.key | translate }}
			</th>
			<td mat-cell *matCellDef="let row" [attr.data-title]="'i18n.mmmi.verification.status.columns.' + column.key | translate">
				<div *ngIf="column.key === 'status'; then statusCell; else otherCell"></div>
				<ng-template #statusCell>
					<strong
						[ngClass]="column.cell(row).toLowerCase()"
						[matTooltip]="'i18n.mmmi.verification.status.tips.' + row.tip | translate: { userId: row.remoteid, userName: model.getUserName(row) }"
						matTooltipPosition="after"
					>
						<span *ngIf="row.tip == 'weak_security'; then alertCell; else statusCell"></span>
						<ng-template #alertCell>
							<span style="color: red">
							{{ column.cell(row) }}
							</span>
						</ng-template>
						<ng-template #statusCell>
							{{ column.cell(row) }}
						</ng-template>
					</strong>
				</ng-template>
				<ng-template #otherCell>
					<div *ngIf="column.key === 'jwtProp2'; then qoa;else  normalCell"></div>
					 <ng-template #qoa>
						 <strong
							 [ngClass]="column.cell(row).toLowerCase()"
							 [matTooltip]="'' + row.acrTip"
							 matTooltipPosition="after"
						 >
							 {{ column.cell(row) }}
						 </strong>
					 </ng-template>
					<ng-template #normalCell>
						{{ column.cell(row) }}
					</ng-template>

				</ng-template>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="model.displayedColumns"></tr>
		<tr mat-row *matRowDef="let row; columns: model.displayedColumns"></tr>
	</table>
</div>
